import React from "react";
import location from "images/location.png";

const LocationSection: React.FC = () => {
  return (
    <section className="bg-black text-white py-16 px-8 flex flex-col lg:flex-row items-center lg:items-start justify-between gap-12">
      {/* Left Content */}
      <div className="max-w-lg">
        <h2 className="text-5xl font-bold">
          We’re Here in New York <br />
          <span className="text-green-500">Ready When You Are</span>
        </h2>
        <p className="text-gray-400 mt-4 leading-relaxed">
          Looking to explore New York City or need a car for a day, weekend, or
          long-term rental? We’ve got you covered! With our extensive fleet of
          luxury, electric, and economy vehicles, you can explore the city or
          venture out of town with comfort and ease. From stylish sedans to
          eco-friendly electric cars, your perfect ride is just around the
          corner. Quick, reliable, and always nearby.
        </p>
      </div>

      {/* Right Content - Image */}
      <div className="relative ">
        <img src={location} alt="New York" className="max-w-sm rounded-3xl" />
      </div>
    </section>
  );
};

export default LocationSection;
